(()=>{
  const menu=document.querySelector('[data-v9-mobile-menu]');
  const openBtn=document.querySelector('[data-v9-menu-open]');
  const closeBtn=menu?.querySelector('[data-v9-menu-close]');
  if(!menu||!openBtn)return;

  /* Move the fullscreen drawer outside Shopify's sticky/backdrop-filter header
     so position:fixed is always relative to the viewport on mobile browsers. */
  if(menu.parentElement!==document.body) document.body.appendChild(menu);

  let lastFocus=null;
  const setOpen=(open)=>{
    menu.classList.toggle('is-open',open);
    menu.setAttribute('aria-hidden',open?'false':'true');
    openBtn.setAttribute('aria-expanded',open?'true':'false');
    document.body.classList.toggle('v9-menu-open',open);
    document.documentElement.classList.toggle('v9-menu-open',open);
    if(open){
      lastFocus=document.activeElement;
      requestAnimationFrame(()=>closeBtn?.focus({preventScroll:true}));
    }else if(lastFocus instanceof HTMLElement){
      requestAnimationFrame(()=>lastFocus.focus({preventScroll:true}));
    }
  };

  openBtn.addEventListener('click',(e)=>{e.preventDefault();e.stopPropagation();setOpen(true)});
  closeBtn?.addEventListener('click',(e)=>{e.preventDefault();setOpen(false)});
  menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setOpen(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.classList.contains('is-open'))setOpen(false)});
  addEventListener('resize',()=>{if(innerWidth>989&&menu.classList.contains('is-open'))setOpen(false)},{passive:true});
})();
